module.exports = __webpack_public_path__ + "img/UG.6368fa8f.svg";